/**
 * src/lib/debug/debugClient.js — read-side helpers for the debug panel.
 * All network reads go through api/data.js action=debug-logs (CEO-gated).
 *
 * apiFetch signature: apiFetch(url, fetchOptions)
 * debug-logs is a POST — limit + types live in req.body, not query params.
 */

import { apiFetch, API_BASE } from '../api/client.js';
import { getTraceContext, getActiveNavCorrelationId } from '../observability.js';

export async function fetchDebugLogs({ limit = 100, types } = {}) {
  try {
    const body = { action: 'debug-logs', limit };
    if (types) body.types = types;
    const res = await apiFetch(`${API_BASE}/data`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    if (!res?.ok) return [];
    return Array.isArray(res.logs) ? res.logs : [];
  } catch {
    return [];
  }
}

export function getLiveContextSnapshot() {
  return {
    route: typeof window !== 'undefined' ? window.location?.pathname || null : null,
    trace: getTraceContext(),
    correlationId: getActiveNavCorrelationId(),
  };
}
